var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.EChartSettings)?_c('div',[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.EChartSettings,"init-options":_vm.initOptions}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }